import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser';
import styles from './styles.module.scss'

const JobTitle = ({ vacationInfo, info }) => {
	let vacationInfoReal =  vacationInfo ? vacationInfo : info
  let _description = <></>
  if(vacationInfoReal?.description) {
    _description = <>{parse(vacationInfoReal?.description)}</>
  }

  return (
    <div className={styles.wrapper}>
      <p className={styles.wrapper_description}>{_description}</p>
      <div className={styles.wrapper_active_filter}>
        <div className={styles.wrapper_active_filter_item}>
          <p className={styles.wrapper_active_filter_item_p1}>Направление</p>
          <p>{vacationInfoReal?.unitDirection?.unitDirectionName}</p>
        </div>

        <div className={styles.wrapper_active_filter_item}>
          <p className={styles.wrapper_active_filter_item_p1}>Локация</p>
          <p>{vacationInfoReal?.city?.name}</p>
        </div>

        <div className={styles.wrapper_active_filter_item}>
          <p className={styles.wrapper_active_filter_item_p1}>Тип занятости</p>
          <p>{vacationInfoReal?.employmentType}</p>
        </div>

        <div className={styles.wrapper_active_filter_item}>
          <p className={styles.wrapper_active_filter_item_p1}>Опыт работы</p>
          <p>{vacationInfoReal?.experience}</p>
        </div>
      </div>
    </div>
  )
}

export default JobTitle
